import { render, staticRenderFns } from "./SBButton.html?vue&type=template&id=4d8a754a&scoped=true&"
import script from "./SBButton.ts?vue&type=script&lang=ts&"
export * from "./SBButton.ts?vue&type=script&lang=ts&"
import style0 from "./SBButton.css?vue&type=style&index=0&id=4d8a754a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a754a",
  null
  
)

export default component.exports